import { createStore, applyMiddleware } from "redux";
import { reducers } from "./reducers/index";
import sagas from "./sagas/index";
import createSagaMiddleware from "redux-saga";

function storeFactory() {
	let middlewares = [];

	const sagaMiddleware = createSagaMiddleware();
	middlewares.push(sagaMiddleware);

	let middleware = applyMiddleware(...middlewares);

	const store = createStore(reducers, middleware);
	sagaMiddleware.run(sagas);
	return store;
}

const store = storeFactory();

export { store, storeFactory };


// WEBPACK FOOTER //
// ./src/store.js